import StoryHero from 'components/story/StoryHero';
import StoryTimeline from 'components/story/StoryTimeline';
import FoundersSection from 'components/story/FoundersSection';
import EmotionalSection from 'components/story/EmotionalSection';
import PageMeta from 'components/layout/PageMeta';

export const metadata = {
  title: 'Our Story',
  description: 'Discover the story behind Mora - a brand born from a simple idea to bring back the warmth, taste and comfort of home through premium roasted peanuts.',
};

export default function StoryPage() {
  return (
    <main className="min-h-screen bg-Mora-ivory">
      <PageMeta title={metadata.title} description={metadata.description} />
      <StoryHero />
      <StoryTimeline />
      {/* <FoundersSection /> */}
      <EmotionalSection />
    </main>
  );
}
